import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import PublicErrorBoundary from "@/shared/components/error-boundary/public-error-boundary";
import { PATH_ROUTER } from "@/shared/models/const/path";
import GoogleCallbackApp from "./auth/google-callback-app";
import GoogleCallbackConnectApp from "./auth/google-callback-connect-app";
import LoginPage from "@/public/auth/login";
import GoogleCallback from "@/public/auth/google-callback";
const ForgotPasswordPage = React.lazy(() => import("@/public/auth/forgot-password"));
const ResetPasswordPage = React.lazy(() => import("@/public/auth/reset-password"));
const WelcomeUserPage = React.lazy(() => import("@/public/auth/welcome-user"));

function PublicRouter() {
  return (
    <PublicErrorBoundary>
      <Routes>
        <Route path={`/${PATH_ROUTER.PUBLIC.AUTH.LOGIN}`} element={<LoginPage />} />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.FORGOT_PASSWORD}`}
          element={<ForgotPasswordPage />}
        />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.RESET_PASSWORD}/:user_id`}
          element={<ResetPasswordPage />}
        />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.WELCOME_USER}/:user_id`}
          element={<WelcomeUserPage />}
        />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.REDIRECT_GOOGLE_AUTH}`}
          element={<GoogleCallback />}
        />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.REDIRECT_GOOGLE_AUTH_APP}`}
          element={<GoogleCallbackApp />}
        />
        <Route
          path={`/${PATH_ROUTER.PUBLIC.AUTH.GOOGLE_AUTH_CONNECT_APP}`}
          element={<GoogleCallbackConnectApp />}
        />
        <Route
          path="*"
          element={<Navigate replace to={`${PATH_ROUTER.PUBLIC.AUTH.LOGIN}`} />}
        />
      </Routes>
    </PublicErrorBoundary>
  );
}

export default PublicRouter;
